<template>
  <ul
    :class="[
      isManage && 'manage'
    ]"
  >
    <li
      v-for="(node, index) in nodes"
      :key="index"
      :style="
        `margin-left: ${node.level > 1 ? '35px' : '0px'};`
      "
    >
      <div
        v-if="node.type == 'account'"
        :class="[
          `${isManage ? 'manage' : 'view'}-${node._id}`
        ]"
        class="wrapper-item"
        @click="clickNode(node)"
        @mouseover="onMouseover(node)"
        @mouseleave="onMouseleave(node)"
      >
        <div class="account">
          <div
            v-if="node.children"
            class="icon">
            <template v-if="node.is_group">
              <i
                v-if="node.open"
                class="far fa-folder-open"/>
              <i
                v-else
                class="far fa-folder"/>
            </template>
            <template v-else>
              <i class="far fa-file-alt"/>
            </template>
          </div>
          <div>
            {{ node.account_code }}
            -
            {{ getMasterDataText(node.account_name, $t) }}
          </div>
        </div>
        <div
          v-if="(() => {
            if(isManage) {
              return false
            }
            if(node.open) {
              if(node.level > 1) {
                return false
              }
            }
            return true
          })()"
          class="balance">
          {{ getNumber(node.balance) }}
        </div>
      </div>
      <div
        v-if="node.type == 'action' && isManage"
        class="wrapper-action my-2">
        <BaseButton
          class="btn-sm"
          @click="addGroup(node)"
        >
          + {{ $t('apps.accounting.button.addgroup') }}
          <i class="far fa-folder"/>
        </BaseButton>
        <BaseButton
          class="btn-sm"
          @click="addAccount(node)"
        >
          + {{ $t('apps.accounting.button.addaccount') }}
          <i class="far fa-file-alt"/>
        </BaseButton>
      </div>
      <TreeItem
        v-if="node.children && node.open"
        :master="master"
        :nodes="node.children"
        :isManage="isManage"
        @onClickNode="(node) => $emit('onClickNode', node)"
        @onAddGroup="addGroup"
        @onAddAccount="addAccount"
        @onToggleNode="(node) => $emit('onToggleNode', node)"
      />
    </li>
  </ul>
</template>

<script>
import { getMasterDataText } from '../../helpers'

export default {
  name: 'TreeItem',
  props: {
    master: Array,
    nodes: Array,
    isManage: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      getMasterDataText,
    }
  },
  methods: {
    findAccountByCode(nodes, code) {
      for (const account of nodes) {
        if (account.account_code === code) {
          return account
        }
        if (account.children && account.children.length > 0) {
          const found = this.findAccountByCode(account.children, code)
          if (found) return found
        }
      }
      return null
    },
    setActiveNode(node) {
      const elements = document.getElementsByClassName(`${this.isManage ? 'manage' : 'view'}-${node._id}`)
      const el = elements.length && elements[0]
      if (el) {
        el.classList.add('active')
        if (node.is_group) {
          el.classList.add('group')
        }
      }
    },
    setInactiveNode(node) {
      const elements = document.getElementsByClassName(`${this.isManage ? 'manage' : 'view'}-${node._id}`)
      const el = elements.length && elements[0]
      if (el) {
        el.classList.remove('active')
        el.classList.remove('group')
      }
    },
    clearActiveNodes() {
      const elements = document.querySelectorAll('.wrapper-item.active')
      elements.forEach((el) => {
        el.classList.remove('active')
        el.classList.remove('group')
      })
    },
    clickNode(node) {
      if (node.is_group) {
        node.open = !node.open
        this.$emit('onToggleNode', node)
      }
      if (this.isManage && node.level > 1) {
        this.clearActiveNodes()
        this.$nextTick(() => {
          this.setActiveNode(node)
        })
      }
      this.$emit('onClickNode', node)
    },
    onMouseover(node) {
      if (this.isManage) {
        return
      }
      this.setActiveNode(node)
    },
    onMouseleave(node) {
      if (this.isManage) {
        return
      }
      this.setInactiveNode(node)
    },
    addGroup(node) {
      this.clearActiveNodes()
      this.$emit('onAddGroup', node)
    },
    addAccount(node) {
      this.$emit('onAddAccount', node)
    },
  },
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

li {
  display: flex;
  flex-direction: column;
}

.wrapper-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  cursor: default;
}

.wrapper-item .account {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wrapper-item .account .icon {
  font-size: 20px;
}

.wrapper-item.active {
  background-color: rgb(239, 239, 239);
}
ul.manage .wrapper-item.active {
  background-color: #f8f9fa;
}
ul.manage .wrapper-item:hover {
  cursor: pointer;
}
.wrapper-item.active.group {
  cursor: pointer;
}

.wrapper-action {
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/TreeItem.vue